import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/error.tsx");
